import React, { useEffect, useRef } from 'react';
import { DefaultValues, FieldValues, FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { cloneDeep, isEqual } from 'lodash-es';

import { DocumentInspectorProps } from '../types';

export interface InspectorFormProviderProps<T extends FieldValues> extends DocumentInspectorProps<T> {
  children: React.ReactNode;
  form?: UseFormReturn<T>;
}

export function InspectorFormProvider<T extends FieldValues>(
  props: InspectorFormProviderProps<T>,
): React.ReactElement {
  const { value, form: initialForm, onChange, children } = props;

  const form = initialForm ?? useForm({
    defaultValues: value.props as DefaultValues<T>,
    mode: 'onBlur',
  });
  const formValue = form.watch();

  const prevFormValueRef = useRef<FieldValues>();

  useEffect(() => {
    if (!isEqual(prevFormValueRef.current, formValue)) {
      onChange({
        ...value,
        props: formValue as T,
      });
      prevFormValueRef.current = cloneDeep(formValue);
    }
  }, [formValue]);

  useEffect(() => {
    form.reset(value.props);
  }, [props.value.key]);

  return (
    <FormProvider {...form}>
      { children }
    </FormProvider>
  );
}
